export default __webpack_public_path__ + "static/media/preguntasFrecuentes2.076e74b2.svg";